module.exports = __webpack_public_path__ + "media/article2_2.56135552.mp4";